import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { getAxios, postAxiosWithToken, putAxiosWithToken } from "../../../service/apiservice";
import { branchListEndPoint, departmentEndPoint } from "../../../service/api";
import { toast } from "react-hot-toast";
import { useKeyPress } from "../../../hooks/useKeyPress";
import { useEffect, useState } from "react";

export default function DepartmentForm({ getData, formMode, currentDepartment, setFormMode, setCurrentDepartment,  }) {

    const[branchDropdown,setbranchDropdown]= useState([]);


    const schema = yup
        .object({
            department_name: yup.string().required(),
        })
        .required()

    const {
        register,
        handleSubmit,
        formState: { errors },
        reset
    } = useForm({
        resolver: yupResolver(schema),
        values: formMode === 'update' ? {
            department_name: currentDepartment.department_name,

        } : {
            department_name: "",
        }
    })

    const onKeyPress = (event) => {
        if (event.ctrlKey && event.key === 's') {
            event.preventDefault();
            document.getElementById('formsubmit').click()
            document.getElementById('forminit').blur()
        } else if (event.ctrlKey && event.key === 'e') {
            event.preventDefault();
            reset()
            clearData()
            setFormMode('create')
        }
    };

    useKeyPress(['s', 'e'], onKeyPress);

    const onSubmit = (data) => {


        if (data !== '') {
            if (formMode === 'create') {
                createDepartment(data)
            } else {
                updateDepartment(data)
            }
        } else {
            errors.showMessages()
        }
    }

    const createDepartment = async (body) => {
        var response = await postAxiosWithToken({
            url: departmentEndPoint,
            body: body
        })
        if (response !== null) {
            
            getData()
            reset()
            toast.success(response.message)
        }
    }

    const updateDepartment = async (body) => {
        var response = await putAxiosWithToken({
            url: departmentEndPoint + currentDepartment?.id + '/',
            body: body
        })

        if (response !== null) {
            getData()
            reset()
            clearData()
            setFormMode('create')
            toast.success(response.message)
        }
    }

    const clearData = () => {
        setCurrentDepartment({ department_name: '' })
    }









    return (
        <>
            <div>
                <form className="grid xl:grid-cols-3 sm:grid-cols-3 gap-5" onSubmit={handleSubmit(onSubmit)}>
                    <div className="my-[5px]">
                        <p className="mb-[5px] text-[15px]">Department Name</p>
                        <input
                            type="text"
                            placeholder="department name"
                            className="sm:mb-[5px] border border-gray-300 rounded-lg w-full p-[10px] text-[17px] outline-none"
                            name="department_name"
                            id="forminit"
                            {...register('department_name')}
                        />
                        <p className="text-red-500 font-[400] text-[13px]">{errors.department_name?.message}</p>
                    </div>
                    
                    <div className="min-[423px]:flex gap-4 mt-0 sm:mt-[35px]">
                        <button
                            type="submit"
                            id="formsubmit"
                            className="capitalize bg-primary text-white w-full rounded-lg p-[10px] h-fit font-[500] text-[17px] outline-none border-none"
                        >save</button>
                        <button
                            onClick={(e) => { e.preventDefault(); clearData(); setFormMode('create'); reset() }}
                            className="max-[423px]:mt-[10px] border border-white capitalize bg-secondary text-white w-full rounded-lg p-[10px] h-fit font-[500] text-[17px] outline-none"
                        >Reset</button>
                    </div>
                </form>
            </div>
        </>
    );
}